type ClassArray = string | number[]
type OptionalBoolean = boolean | null | undefined
type ClassObject = Record<string, OptionalBoolean>
type Arg = ClassArray | ClassObject | string | number | OptionalBoolean

/**
 * Convenience function for constructing a classlist with better DX
 */
export default function clx(...args: Arg[]): string {
	const classes: string[] = []

	args.forEach(arg => {
		if (!arg) return // skip if falsy

		if (typeof arg === 'string' || typeof arg === 'number') {
			classes.push(String(arg))
		} else if (Array.isArray(arg)) {
			classes.push(clx(...arg)) // recursively call this function
		} else if (typeof arg === 'object') {
			Object.entries(arg).forEach(([key, truthy]) => {
				if (truthy) classes.push(key)
			})
		}
	})

	return classes.join(' ')
}
